// @ts-ignore
/* eslint-disable */
import request from "@/request";

/** 提交代码 POST /question-submit/add */
export async function doQuestionSubmit(
  body: API.QuestionSubmitAddRequest,
  options?: { [key: string]: any }
) {
  return request<API.BaseResponseLong>("/question-submit/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 根据 id 获取提交记录（仅提交者或管理员可查看） GET /question-submit/get */
export async function getQuestionSubmitById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getQuestionSubmitByIdParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResponseQuestionSubmitVO>("/question-submit/get", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 分页查询提交记录（普通用户仅看自己的，管理员看全部） POST /question-submit/list/page */
export async function listQuestionSubmitByPage(
  body: API.QuestionSubmitQueryRequest,
  options?: { [key: string]: any }
) {
  return request<API.BaseResponsePageQuestionSubmitVO>(
    "/question-submit/list/page",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
